module.exports = __webpack_public_path__ + "img/9788982731945.b6d298ae.jpg";